import styles from './Loader.module.scss';

interface ILoaderProps {
  isLoading: boolean;
}

export const Loader = ({ isLoading }: ILoaderProps) => {
  return (
    <div>
      {isLoading && (
        <div className={styles.LoaderWrap}>
          <div className={styles.Loader} />
        </div>
      )}
    </div>
  );
};
